import { useEffect } from 'react'
import { isAusGaUser } from '../../constants'
import { useCheckUnableHomePage } from '../../hooks/useCheckUnableHomePage/useCheckUnableHomePage'
import { redirectUser } from '../../utils/redirectToHome'
import { useAppContext } from '../app'

/**
 * Redirects the user based on the status of a feature flag.
 * @param {string} featureFlagKey - The key of the feature flag to check.
 */
const useFeatureFlagRedirect = (redirect?: boolean) => {
  const { userRole, portfolioCountryCode } = useAppContext()
  const { redirectUrl } = useCheckUnableHomePage()

  // Temporary :'(
  useEffect(() => {
    // Reasoning for hijack: Until AUS GA users get merged like all other roles to include GA+MA view
    if (redirect && isAusGaUser(portfolioCountryCode, userRole)) {
      redirectUser(portfolioCountryCode, userRole, undefined, redirectUrl)
    }

    // Otherwise regular logic
    if (!redirect) {
      redirectUser(portfolioCountryCode, userRole, undefined, redirectUrl)
    }
  }, [portfolioCountryCode, userRole])
}

export default useFeatureFlagRedirect
